import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const NAMES = ['María G.', 'Carolina P.', 'Ana L.', 'Sofía R.', 'Laura M.', 'Valentina S.', 'Camila D.', 'Isabella T.', 'Lucía F.', 'Gabriela H.', 'Patricia V.', 'Andrea C.', 'Diana B.', 'Rosa E.', 'Elena K.'];
const CITIES = ['Ciudad de México', 'Buenos Aires', 'Bogotá', 'Lima', 'Santiago', 'Madrid', 'Barcelona', 'Medellín', 'Guadalajara', 'Quito', 'Montevideo', 'San José'];
const TIMES = ['hace 2 minutos', 'hace 5 minutos', 'hace 8 minutos', 'hace 12 minutos', 'hace 15 minutos', 'hace 20 minutos'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
interface Notification {
  name: string;
  city: string;
  time: string;
  id: number;
}
export function RecentPurchaseNotification() {
  const [notification, setNotification] = useState<Notification | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showNotification = () => {
      const newNotification: Notification = {
        name: getRandomItem(NAMES),
        city: getRandomItem(CITIES),
        time: getRandomItem(TIMES),
        id: Date.now()
      };
      setNotification(newNotification);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialDelay = setTimeout(() => {
      showNotification();
    }, 8000);
    const interval = setInterval(() => {
      showNotification();
    }, 25000 + Math.random() * 15000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  if (!notification) return null;
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm ${isVisible ? 'notification-enter' : 'notification-exit'}`} role="status" aria-live="polite" data-id="element-224">
      <div className="bg-spiritual-800/95 backdrop-blur-md border border-spiritual-400/30 rounded-xl p-4 shadow-2xl shadow-spiritual-900/50" data-id="element-225">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-spiritual-300/50 hover:text-spiritual-300 transition-colors" aria-label="Cerrar notificación" data-id="element-226">
          <XIcon className="w-3.5 h-3.5" data-id="element-227" />
        </button>
        <div className="flex items-center gap-3" data-id="element-228">
          <div className="flex-shrink-0 w-10 h-10 bg-spiritual-700 rounded-full flex items-center justify-center border border-spiritual-400/20" data-id="element-229">
            <ShoppingBagIcon className="w-5 h-5 text-spiritual-400" aria-hidden="true" data-id="element-230" />
          </div>
          <div className="min-w-0" data-id="element-231">
            <p className="text-spiritual-100 font-body text-sm font-bold truncate" data-id="element-232">
              {notification.name} — {notification.city}
            </p>
            <p className="text-spiritual-300/70 font-body text-xs" data-id="element-233">
              Compró el Código de Sanación · {notification.time}
            </p>
          </div>
        </div>
      </div>
    </div>;
}